import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { DragAndDropAngularModule } from 'rev-shared/ui/dragAndDrop/DragAndDrop.AngularModule';
import { FileUploadAngularModule } from 'rev-shared/ui/fileUpload/FileUpload.AngularModule';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { SelectAngularModule } from 'rev-shared/ui/select/SelectAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';
import { VbUiColorSelectorModule } from 'rev-shared/ui/color-selector/VbUiColorSelector.Module';
import { VbUiToggleContentDisplayAngularModule } from 'rev-shared/ui/toggleContentDisplay/VbUiTogleContentDisplay.AngularModule';
import { VideoPlayerAngularModule } from 'rev-shared/videoPlayer/VideoPlayerAngular.Module';

import { BackstageViewComponent } from './backstage/BackstageView.Component';

import { AudioPresentersComponent } from './backstage/videoPreview/AudioPresenters.Component';
import { OnstageViewComponent } from './backstage/videoPreview/OnstageView.Component';
import { PreviewViewComponent } from './backstage/videoPreview/PreviewView.Component';
import { VideoPreviewPlayerComponent } from './backstage/videoPreview/VideoPreviewPlayer.Component';
import { VideoPreviewPlayerTileComponent } from './backstage/videoPreview/VideoPreviewPlayerTile.Component';

import { BannerRendererComponent } from './backstage/banner/BannerRenderer.Component';
import { VideoBannerComponent } from './backstage/banner/VideoBanner.Component';

import { PresenterVideoComponent } from './backstage/controls/PresenterVideo.Component';
import { PresenterVideoListComponent } from './backstage/controls/PresenterVideoList.Component';
import { ProducerControlsSidebarComponent } from './backstage/controls/ProducerControlsSidebar.Component';
import { ProducerVideoControlsComponent } from './backstage/controls/ProducerVideoControls.Component';
import { SceneSelectorComponent } from './backstage/controls/SceneSelector.Component';

import { LayoutIconComponent } from './LayoutIcon.Component';
import { ProducerSetupComponent } from './ProducerSetup.Component';
import { ProducerViewComponent } from './ProducerView.Component';
import { ProducerSidebarComponent } from './ProducerSidebar.Component';

@NgModule({
	declarations: [
		AudioPresentersComponent,
		BackstageViewComponent,
		BannerRendererComponent,
		OnstageViewComponent,
		LayoutIconComponent,
		PresenterVideoComponent,
		PresenterVideoListComponent,
		PreviewViewComponent,
		ProducerControlsSidebarComponent,
		ProducerSetupComponent,
		ProducerSidebarComponent,
		ProducerVideoControlsComponent,
		ProducerViewComponent,
		SceneSelectorComponent,
		VideoBannerComponent,
		VideoPreviewPlayerComponent,
		VideoPreviewPlayerTileComponent
	],
	exports: [
		ProducerViewComponent,
		ProducerSidebarComponent,
		ProducerControlsSidebarComponent
	],

	imports: [
		BsDropdownModule,
		ButtonsAngularModule,
		CarouselModule,
		CollapseModule,
		CommonModule,
		CssRulesAngularModule,
		DirectivesAngularModule,
		DragAndDropAngularModule,
		FileUploadAngularModule,
		FormGroupAngularModule,
		FormsModule,
		SelectAngularModule,
		SpinnerAngularModule,
		TooltipModule,
		TranslateModule,
		ValidationAngularModule,
		VbProfilePictureModule,
		VbUiColorSelectorModule,
		VbDropdownMenuModule,
		VbUiToggleContentDisplayAngularModule,
		VideoPlayerAngularModule
	]
})
export class ProducerModule {}

